import Vue from 'vue'
import { MonthPicker } from 'vue-month-picker'
import MonthPickerInput from '../components/widgets/calendar/MonthPickerInput.vue'
// Vue.use(MonthPicker)
// Vue.use(MonthPickerInput)
Vue.component('month-picker', MonthPicker)
Vue.component('month-picker-input', MonthPickerInput)
